import { loadStaticCustomerSport } from "./staticCustomerSportsClient";

const identityOf = (payload) => ({
  version_id: String(payload?.version?.version_id || ""),
  source_sha256: String(payload?.version?.source_sha256 || ""),
});

export function createStaticCustomerReleaseMonitor({
  sport,
  getCurrentIdentity,
  onRelease,
  onError = () => {},
  loadRelease = loadStaticCustomerSport,
  documentObject = document,
  windowObject = window,
  intervalMs = 60000,
}) {
  let stopped = false;
  let inFlight = false;
  let interval = null;
  let requestGeneration = 0;

  const check = async () => {
    if (stopped || inFlight || documentObject.visibilityState === "hidden") return;
    inFlight = true;
    const generation = ++requestGeneration;
    try {
      const payload = await loadRelease(sport);
      if (stopped || generation !== requestGeneration) return;
      const next = identityOf(payload);
      const current = getCurrentIdentity() || {};
      if (!next.version_id || !next.source_sha256) throw new Error("Static customer release identity is incomplete");
      if (next.version_id === current.version_id && next.source_sha256 === current.source_sha256) return;
      onRelease(payload, next);
    } catch (error) {
      if (!stopped && generation === requestGeneration) onError(error);
    } finally {
      if (generation === requestGeneration) inFlight = false;
    }
  };

  const stopInterval = () => {
    if (interval !== null) windowObject.clearInterval(interval);
    interval = null;
  };
  const startInterval = () => {
    stopInterval();
    if (!stopped && documentObject.visibilityState !== "hidden") {
      interval = windowObject.setInterval(check, intervalMs);
    }
  };
  const onVisibility = () => {
    if (documentObject.visibilityState === "hidden") stopInterval();
    else { check(); startInterval(); }
  };
  const onFocus = () => { check(); };

  documentObject.addEventListener("visibilitychange", onVisibility);
  windowObject.addEventListener("focus", onFocus);
  startInterval();

  return {
    check,
    stop() {
      if (stopped) return;
      stopped = true;
      requestGeneration += 1;
      stopInterval();
      documentObject.removeEventListener("visibilitychange", onVisibility);
      windowObject.removeEventListener("focus", onFocus);
    },
  };
}
